import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DatadogContextState {
  userUuid: string | null;
  laboratoryCode: string | null;
  customerCode: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DatadogContextStateService {
  private _state$ = new BehaviorSubject<DatadogContextState>({
    userUuid: null,
    laboratoryCode: null,
    customerCode: null,
  });

  public get currentState(): DatadogContextState {
    return this._state$.value;
  }

  public get state$(): Observable<DatadogContextState> {
    return this._state$.asObservable();
  }

  public clearContext(): void {
    this._state$.next({
      userUuid: null,
      laboratoryCode: null,
      customerCode: null,
    });
  }

  public setCustomerCode(customerCode: string | null): void {
    this._state$.next({
      ...this._state$.value,
      customerCode,
    });
  }

  public setLaboratoryCode(laboratoryCode: string | null): void {
    this._state$.next({
      ...this._state$.value,
      laboratoryCode,
    });
  }

  public setUserUuid(userUuid: string | null): void {
    this._state$.next({
      ...this._state$.value,
      userUuid,
    });
  }
}
